import React from 'react';
import DefaultTextfield from '@material-ui/core/TextField';

const TextField = React.forwardRef((props, ref) => {
  const defaultProps = {
    fullWidth: true,
    margin: 'normal',
    variant: 'outlined',
  };
  return (
    <DefaultTextfield ref={ref} {...defaultProps} {...props} />
  );
});

export default TextField;
